import React, { useMemo } from "react";
import useFetchClaims from "hooks/useFetchClaims";
import {
  ClaimsSummaryWrapper,
  CoverageDetailsCard,
  ProductFooter,
} from "../styles";
import { Ptag } from "components/core";
import BaseLinkButton from "components/core/BaseLinkButton";
import { startCase } from "lodash";
import { addLeadingZero, formatDateReverse } from "utlis/utils";

function ClaimsView() {
  const { claims, loading } = useFetchClaims();
  const sortedClaimsSummary = useMemo(() => {
    if (!claims) return [];
    return Object.entries(claims?.claim_summary)
      .filter(([key, _]) => key !== "updated_at")
      .sort(([name, a], [nextName, b]) => {
        if (name === "Total Claims Submitted") return -1;
        if (nextName === "Total Claims Submitted") return 1;
        if (a < b) return 1;
        if (a > b) return -1;
        return 0;
      })
      .map(([key, val]) => {
        const text_field = key;
        return { [text_field]: val };
      });
  }, [claims]);

  return (
    <CoverageDetailsCard style={{ gridColumn: "3/-1", overflowX: "auto" }}>
      <header
        style={{
          display: "flex",
          alignItems: "flex-end",
          marginBottom: "14px",
          gap: "6px",
        }}
      >
        <Ptag fontSize="18px">Claims Summary</Ptag>
        {claims?.claim_summary?.updated_at && (
          <Ptag color="#6E6097" fontSize="14px">
            (as on{" "}
            {formatDateReverse(claims.claim_summary.updated_at)})
          </Ptag>
        )}
      </header>
      <ClaimsSummaryWrapper>
        {sortedClaimsSummary.map((status, index) =>
          Object.entries(status).map(([key, value]) => (
            <div key={index}>
              <Ptag
                color="#646075"
                fontWeight="400"
                marginBottom="8px"
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                {startCase(key.toLowerCase())}
              </Ptag>
              <Ptag fontWeight="700" fontSize="20px">
                {addLeadingZero(value)??'-'}
              </Ptag>
            </div>
          ))
        )}
      </ClaimsSummaryWrapper>
      <ProductFooter>
        {sortedClaimsSummary[0]?.length > 0 && (
          <BaseLinkButton label="View All" path="/v1/claims" />)}
      </ProductFooter>
    </CoverageDetailsCard>
  );
}

export default ClaimsView;
